module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/store_images/4_441d1a480fa3de7b9a62cb27cefc1987.png";